import { color } from 'd3-color';
import { interpolateSinebow } from 'd3-scale-chromatic';

import { isSet } from 'rise-ui/utils/nullish.js';

export function numberToColor(value) {
  return '#' + (value & 0xffffff).toString(16).padStart(6, '0');
}

export const contrastingColorsDefaultOptions = {
  // Color function for source hues
  fn: interpolateSinebow,
  // True if color function wraps around to original color; i.e. fn(0) === fn(1)
  // Note: although cyclic may be true for default color function, cyclic will
  // default to false if color function given with call to contrastingColors().
  cyclic: true,
  // Minimum number of hues to use before shading and at all times
  minHues: 6,
  // Manipulate to get more/less hues per shade
  hueShadeRatio: 1.5,
  // Min/max amount of shade to add to hue; rgb * Math.pow(0.7, shade)
  // e.g. 128 * Math.pow(0.7, 0) === 128; e.g. 128 * Math.pow(0.7, 2) === 62.72
  minShade: 0,
  maxShade: 2,
};

export function contrastingColors(count, options) {
  count = Math.max(1, count);
  options = options || {};
  options = {
    ...contrastingColorsDefaultOptions,
    ...options,
    cyclic: (isSet(options.cyclic) || options.fn ? options : contrastingColorsDefaultOptions).cyclic,
  };
  const hues = Math.floor(Math.max(Math.sqrt(count) * options.hueShadeRatio, options.minHues));
  const hueMax = hues + (options.cyclic ? 1 : 0);
  const shades = Math.ceil(count / hues);
  const shadeRange = Math.abs(options.maxShade - options.minShade);
  const shadeStart = Math.min(options.minShade, options.maxShade);
  return value => {
    const index = Math.floor(value * (count - 1));
    const hueIndex = index % hues;
    const hueValue = hueIndex / (hueMax || 1);
    const darkIndex = Math.floor(index / hues);
    const darkValue = darkIndex / (shades || 1);
    return color(options.fn(hueValue))
      .darker(shadeStart + darkValue * shadeRange);
  };
}

const matchHex = /^#(?:([0-9a-f])([0-9a-f])([0-9a-f])|([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2}))$/i;
const matchRgba = /^rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*(\.?\d+|\d+\.\d+)\s*)?\)$/;

export function rgba(color) {
  if (!color || (color = ('' + color).trim()) === '0' || color === '#000' || color === '#000000') {
    return [ 0, 0, 0, 1 ];
  }
  let match = color.match(matchHex);
  if (match) {
    match = match.map(v => parseInt(v, 16));
  } else {
    match = color.match(matchRgba);
  }
  if (match) {
    let [, r, g, b, a ] = match;
    return [ r, g, b, a || 0 ];
  }
  return [ 0, 0, 0, 0 ];
}

export function alpha(color, alpha) {
  const [ r, g, b ] = rgba(color);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}
